import BaseMixin from "@/components/DigitalEvent/mixins/BaseMixin";
import NotificationsMixin from "../../mixins/NotificationsMixin";

/**
 * Common functionality for the Auth components
 */

export default {
  mixins: [BaseMixin, NotificationsMixin],
  mounted() {
    if (this.$refs["focusInput"]) {
      this.$refs["focusInput"].focus();
    }
  },
  computed: {
    /**
     * This title will be used on auth forms
     * @return {String}
     */
    pageTitle() {
      return this.$store.state.event.context.TITLE;
    },

    /**
     * This email will be used on auth forms
     * @return {String}
     */
    emailToRead() {
      return this.$store.state.users.email;
    },

    /**
     * User info
     * @return {Object}
     */
    userInfo() {
      return this.$store.state.users.userInfo;
    },

    /**
     * User
     * @return {Object}
     */
    user() {
      return this.$store.state.users.user;
    },

    /**
     * This name will be used on auth forms
     * @return {String}
     */
    fullName() {
      if (this.firstName && this.lastName) {
        return `${this.firstName} ${this.lastName}`;
      }
      return null;
    },

    /**
     * First Name
     * @return {String}
     */
    firstName() {
      if (this.user && this.user.profile && this.user.profile.firstName) {
        return this.user.profile.firstName;
      } else if (this.userInfo) {
        return this.userInfo.firstName;
      } else if (this.user) {
        return this.user.user_firstname;
      }
      return null;
    },

    /**
     * Last Name
     * @return {String}
     */
    lastName() {
      if (this.user && this.user.profile && this.user.profile.lastName) {
        return this.user.profile.lastName;
      } else if (this.userInfo) {
        return this.userInfo.lastName;
      } else if (this.user) {
        return this.user.user_lastname;
      }
      return null;
    }
  },
  methods: {
    /**
     * Open page based on user status
     * @param user {Object}
     */
    redirectUser(user) {
      if (user && (user.has_one_time_password || user.has_mock_password)) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_RESET_TEMP_PASSWORD);
      } else if (user && user.password_changing) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_SET_NEW_PASSWORD);
      } else if (user && user.user_status === this.USER_STATUSES.ACTIVE) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_TABLE_INFO);
      } else if (user) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_ACCOUNT);
      } else {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_LOGIN);
      }
    },

    /**
     * Show messages to user
     * @param messages {Array}
     */
    showMessages(messages) {
      (messages || []).forEach(m => {
        this.showNotification({ type: "success", message: m });
      });
    },

    /**
     * Show errors to user
     * @param errors {Array}
     */
    showErrors(errors) {
      (errors || []).forEach(e => {
        setTimeout(() => this.showNotification({ type: "error", message: e }), 100);
        /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
        console.error(e);
      });
    }
  }
};
